/**
 * SIS product page behaviour: gallery thumbs, quantity stepper, variant
 * matching, sticky ATC, recommendation section fetch, and order-bump
 * toggle (add/remove without opening the cart drawer).
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseProductJson(root) {
    var node = root.querySelector('[data-sis-product-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (window.SisCart && typeof window.SisCart.formatMoney === 'function') {
      return window.SisCart.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function qtyValue(root) {
    var input = root.querySelector('[data-sis-pdp-qty-input]');
    var value = input ? parseInt(input.value, 10) : 1;
    if (isNaN(value) || value < 1) value = 1;
    if (value > 99) value = 99;
    if (input) input.value = value;
    return value;
  }

  function initGallery(root) {
    var main = root.querySelector('[data-sis-gallery-main]');
    var thumbs = root.querySelectorAll('[data-sis-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-sis-image');
        if (src) main.src = src;
        thumbs.forEach(function (other) {
          var active = other === thumb;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  }

  function selectThumbByMediaId(root, imageId) {
    if (!imageId) return;
    var thumb =
      root.querySelector('[data-sis-gallery-thumb][data-sis-image-id="' + imageId + '"]') ||
      root.querySelector('[data-sis-gallery-thumb][data-sis-media-id="' + imageId + '"]');
    if (thumb) thumb.click();
  }

  function updateVariant(root, product, variant) {
    if (!variant) return;
    var format = root.getAttribute('data-sis-money-format') || '{{amount}}';
    var available = !!variant.available;

    root.querySelectorAll('[data-sis-pdp-add]').forEach(function (btn) {
      btn.setAttribute('data-variant-id', String(variant.id));
      btn.disabled = !available;
    });

    root.querySelectorAll('[data-sis-price]').forEach(function (el) {
      el.textContent = formatMoney(variant.price, format);
    });

    var compare = root.querySelector('[data-sis-compare]');
    var save = root.querySelector('[data-sis-save]');
    var saveAmount = root.querySelector('[data-sis-save-amount]');
    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compare) {
      compare.hidden = !hasCompare;
      if (hasCompare) compare.textContent = formatMoney(variant.compare_at_price, format);
    }
    if (save) {
      save.hidden = !hasCompare;
      if (hasCompare && saveAmount) {
        saveAmount.textContent = formatMoney(variant.compare_at_price - variant.price, format);
      }
    }

    var label = root.querySelector('[data-sis-pdp-atc-label]');
    if (label) {
      var availableLabel = root.getAttribute('data-sis-atc-available') || 'ADAUGĂ ÎN COȘ';
      var soldOutLabel = root.getAttribute('data-sis-atc-sold-out') || 'STOC EPUIZAT';
      label.textContent = available ? availableLabel : soldOutLabel;
    }

    if (variant.featured_image && variant.featured_image.id) {
      selectThumbByMediaId(root, variant.featured_image.id);
    }
  }

  function selectedOptions(root) {
    var values = [];
    root.querySelectorAll('[data-sis-option-index]').forEach(function (fieldset) {
      var selected = fieldset.querySelector('.sis-pdp__option-btn.is-selected');
      values.push(selected ? selected.getAttribute('data-sis-option-value') : '');
    });
    return values;
  }

  function findVariant(product, options) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (variant.options[j] !== options[j]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return product.variants[0] || null;
  }

  function initOptions(root, product) {
    root.querySelectorAll('[data-sis-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fieldset = btn.closest('[data-sis-option-index]');
        if (!fieldset) return;
        fieldset.querySelectorAll('[data-sis-option-value]').forEach(function (other) {
          var active = other === btn;
          other.classList.toggle('is-selected', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateVariant(root, product, findVariant(product, selectedOptions(root)));
      });
    });
  }

  function initQty(root) {
    var wrap = root.querySelector('[data-sis-pdp-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-sis-pdp-qty-input]');
    var minus = wrap.querySelector('[data-sis-pdp-qty-minus]');
    var plus = wrap.querySelector('[data-sis-pdp-qty-plus]');
    if (!input || !minus || !plus) return;
    minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    plus.addEventListener('click', function () {
      input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
    });
    input.addEventListener('change', function () {
      qtyValue(root);
    });
  }

  function initAdd(root) {
    root.querySelectorAll('[data-sis-pdp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;
        if (!window.SisCart || typeof window.SisCart.addItem !== 'function') return;
        var original = btn.innerHTML;
        btn.disabled = true;
        window.SisCart.addItem(variantId, qtyValue(root))
          .then(function () {
            btn.disabled = false;
            btn.innerHTML = original;
          })
          .catch(function () {
            btn.disabled = false;
            btn.innerHTML = original;
            alert('Nu am putut adăuga produsul în coș. Încearcă din nou.');
          });
      });
    });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-sis-sticky-atc]');
    var buy = root.querySelector('[data-sis-buy]');
    if (!sticky || !buy || typeof IntersectionObserver !== 'function') return;

    var observer = new IntersectionObserver(
      function (entries) {
        var buyVisible = entries[0] && entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', !buyVisible);
        sticky.setAttribute('aria-hidden', buyVisible ? 'true' : 'false');
      },
      { threshold: 0, rootMargin: '0px 0px -24px 0px' }
    );
    observer.observe(buy);
  }

  function setBumpChecked(card, checked) {
    if (!card) return;
    card.classList.toggle('is-in-cart', checked);
    var check = card.querySelector('[data-sis-pdp-bump-check]');
    if (check) check.setAttribute('aria-pressed', checked ? 'true' : 'false');
  }

  function findBumpLine(cart, productId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var props = item.properties || {};
      if (String(item.product_id) === String(productId) && props._sis_source === 'order_bump') {
        return item;
      }
    }
    return null;
  }

  function toggleBump(card) {
    if (!card || card.getAttribute('aria-busy') === 'true') return;
    if (!window.SisCart) return;

    var productId = card.getAttribute('data-sis-order-bump-id');
    var variantId = card.getAttribute('data-sis-variant-id');
    if (!productId || !variantId) return;

    card.setAttribute('aria-busy', 'true');

    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var line = findBumpLine(cart, productId);
        if (line) {
          return window.SisCart.removeItem(line.key).then(function () {
            setBumpChecked(card, false);
          });
        }
        var properties = window.SisCart.trackingProperties && window.SisCart.trackingProperties(card);
        return window.SisCart.addItem(variantId, 1, { skipDrawer: true, properties: properties }).then(function () {
          setBumpChecked(card, true);
        });
      })
      .catch(function () {
        alert('Nu am putut actualiza coșul. Încearcă din nou.');
      })
      .then(function () {
        card.removeAttribute('aria-busy');
      });
  }

  function syncBumpsFromCart(cart) {
    var ids = {};
    ((cart && cart.items) || []).forEach(function (item) {
      var props = item.properties || {};
      if (props._sis_source === 'order_bump') ids[String(item.product_id)] = true;
    });
    document.querySelectorAll('[data-sis-pdp-bump]').forEach(function (card) {
      var id = card.getAttribute('data-sis-order-bump-id');
      setBumpChecked(card, !!ids[id]);
    });
  }

  function loadRecommendations() {
    var section = document.querySelector('[data-sis-recs]');
    if (!section) return;
    var url = section.getAttribute('data-url');
    if (!url) return;

    var fetchRecs = function () {
      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-sis-recs]');
          if (fresh && fresh.innerHTML.trim().length) {
            section.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {});
    };

    if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0] || !entries[0].isIntersecting) return;
          observer.disconnect();
          fetchRecs();
        },
        { rootMargin: '0px 0px 200px 0px' }
      );
      observer.observe(section);
    } else {
      fetchRecs();
    }
  }

  function initProduct(root) {
    var product = parseProductJson(root);
    initGallery(root);
    initQty(root);
    initAdd(root);
    initSticky(root);
    if (product) initOptions(root, product);
  }

  ready(function () {
    document.querySelectorAll('[data-sis-product]').forEach(initProduct);
    loadRecommendations();
  });

  document.addEventListener('click', function (e) {
    var fbtBtn = e.target.closest('[data-sis-fbt-add]');
    if (fbtBtn) {
      e.preventDefault();
      var variantId = fbtBtn.getAttribute('data-variant-id');
      if (!variantId || fbtBtn.disabled || !window.SisCart) return;
      var original = fbtBtn.innerHTML;
      fbtBtn.disabled = true;
      window.SisCart.addItem(variantId, 1)
        .then(function () {
          fbtBtn.disabled = false;
          fbtBtn.innerHTML = original;
        })
        .catch(function () {
          fbtBtn.disabled = false;
          fbtBtn.innerHTML = original;
          alert('Nu am putut adăuga produsul în coș. Încearcă din nou.');
        });
      return;
    }

    var card = e.target.closest('[data-sis-pdp-bump]');
    if (!card) return;
    if (e.target.closest('a')) return;
    e.preventDefault();
    toggleBump(card);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    var root = e.target.querySelector('[data-sis-product]');
    if (root) initProduct(root);
    if (e.target.querySelector('[data-sis-recs]')) loadRecommendations();
  });

  document.addEventListener('sis:cart:updated', function (e) {
    syncBumpsFromCart((e.detail && e.detail.cart) || {});
  });
})();
